import { merge } from "@rpldy/shared";
import { DEFAULT_OPTIONS } from "./defaults";

const getMandatoryOptions = options => merge({}, DEFAULT_OPTIONS, options);

export { getMandatoryOptions };